import { ArrowDown, ArrowUp } from "lucide-react";
import React from "react";

import { IgChip, IgTypography } from "@intelligems/ig-theme";
import { ChipProps, useTheme } from "@mui/material";

interface UpliftChipProps extends ChipProps {
  upliftValue: number;
  isInverted?: boolean;
}

export const UpliftChip = (props: UpliftChipProps) => {
  const { upliftValue, isInverted } = props;
  const theme = useTheme();
  const isZero = Math.round(upliftValue * 100) === 0;
  const isPositive = upliftValue > 0;
  const color = isZero
    ? "default"
    : isInverted
      ? isPositive
        ? "error"
        : "success"
      : isPositive
        ? "success"
        : "error";

  const backgroundColor = isZero
    ? "#EBEBEB"
    : isInverted
      ? isPositive
        ? "#FBE9EB"
        : "#EAF7EA"
      : isPositive
        ? "#EAF7EA"
        : "#FBE9EB";

  const label = (
    <IgTypography
      variant={"body2"}
      sx={{
        display: "flex",
        alignItems: "center",
        color: color,
        padding: "0px",
        fontWeight: 600,
        marginBottom: "1px",
      }}
    >
      {isZero ? undefined : isPositive ? (
        <ArrowUp
          size={16}
          color={
            isInverted ? theme.igIconColors.error : theme.igIconColors.success
          }
          style={{
            padding: "0px",
            marginBottom: "2px",
          }}
        />
      ) : (
        <ArrowDown
          size={16}
          color={
            isInverted ? theme.igIconColors.success : theme.igIconColors.error
          }
          style={{
            padding: "0px",
            marginBottom: "1px",
          }}
        />
      )}
      {Math.round(Math.abs(upliftValue * 100))}%
    </IgTypography>
  );

  return (
    <IgChip
      color={color}
      label={label}
      sx={{
        // height: "24px",
        width: isZero ? "35px" : "51px",
        padding: "0px",
        // borderRadius: "10px",
        backgroundColor: backgroundColor,
        marginRight: "10px",
        paddingTop: "3px",
        "& .MuiChip-label": {
          padding: "0px",
          paddingRight: isZero ? "0px" : "5px",
        },
      }}
    />
  );
};
